import {WorkingTime} from '../state/types/WorkingTime';
import {DateTime} from 'luxon';

const CSV_HEADERS = [
    'account_id', 'timeaccount_id', 'is_billable', 'is_billable_combined',
    'billed_in', 'invoice_id', 'is_cleared', 'is_cleared_combined',
    'start_date', 'start_time', 'end_time', 'duration', 'description',
    'need_for_clarification', 'type', 'clock_out_reason', 'relations',
    'tags', 'attachments', 'notes', 'seq', 'tags',
];

const escapeCsvField = (value: string): string => {
    if (value.includes('"') || value.includes(',') || value.includes('\n') || value.includes('\r')) {
        return '"' + value.replace(/"/g, '""') + '"';
    }
    return '"' + value + '"';
};

export const generateTimeTrackingCsv = (
    workingTimeList: WorkingTime[],
    projectId: string,
): string => {
    const headerRow = CSV_HEADERS.map(escapeCsvField).join(',');

    const rows = workingTimeList.map((wt, index) => {
        const start = DateTime.fromJSDate(wt.start);
        const end = DateTime.fromJSDate(wt.end);
        const durationMinutes = wt.durationOnly && wt.durationMinutes
            ? wt.durationMinutes
            : Math.round((wt.end.getTime() - wt.start.getTime()) / 60000);

        const startDate = start.toFormat('yyyy-MM-dd') + ' 00:00:00';
        const startTime = wt.durationOnly ? '' : start.toFormat('HH:mm:ss');
        const endTime = wt.durationOnly ? '' : end.toFormat('HH:mm:ss');
        const tagsStr = wt.tags ? wt.tags.join(', ') : '';

        const fields = [
            wt.employeeId,
            projectId,
            '1',
            '1',
            '',
            '',
            '0',
            '0',
            startDate,
            startTime,
            endTime,
            String(durationMinutes),
            wt.note || '',
            '0',
            'PZ',
            '',
            '',
            tagsStr,
            '',
            '',
            String(index + 1),
            '',
        ];

        return fields.map(escapeCsvField).join(',');
    });

    return [headerRow, ...rows].join('\n');
};

export const downloadCsvFile = (csvContent: string, filename: string): void => {
    const bom = '﻿';
    const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
};
